<div class="message-box" [ngClass]="themeClass">
  <mat-icon>{{ icon }}</mat-icon>
  <div class="message-content">
    <h4 class="message-title">{{ title }}</h4>
    <div class="message-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
